import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  accept_assigned_assessment_kit_candidate_action,
  accept_assigned_assessment_kit_details_candidate_action,
  view_assigned_interview_kit_candidate_action,
} from "../../../redux/_actions/candidate";
import { get_loggedin_user_meta_data_action } from "../../../redux/_actions";

function useAssementKitDetails() {
  const [interviewKit, setInterviewKit] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingError, setLoadingError] = useState();
  const [readMore, setReadMore] = useState(false);
  const [appliedJobId, setAppliedJobId] = useState(null);
  const [acceptLoading, setAcceptLoading] = useState(false);
  const [isDeclineAssessmentModal, setIsDeclineAssessmentModal] =
    useState(false);
  const [utmToken, setUtmToken] = useState(null);
  const [utmId, setUtmId] = useState(null);
  const [user, setUser] = useState(null);
  const [userToken, setUserToken] = useState(null);
  const [userInfo, setUserInfo] = useState({});
  const [candidateAccepted, setCandidateAccepted] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();

  const { acceptAssignedAssessmentKitDetailsData } = useSelector(
    (state) => state.accept_assigned_assessment_kit_details_candidate_reducer
  );

  const { acceptAssignedAssessmentKitData } = useSelector(
    (state) => state.accept_assigned_assessment_kit_candidate_reducer
  );
  const { loggedInMetaData } = useSelector(
    (state) => state.get_loggedin_user_meta_data_reducer
  );

  useEffect(() => {
    if (loggedInMetaData?.data) {
      setUserInfo(loggedInMetaData?.data);
    }
  }, [loggedInMetaData]);
  useEffect(() => {
    const id = params?.id;
    if (id) {
      callApi(id);
    }
    if (userToken) callUserApi();
  }, [userToken]);

  useEffect(() => {
    getUserToken();
    let interviewKitId = params?.id;
    let url = new URL(window.location.href);
    let user = url.searchParams.get("candidate");
    let utmId = url.searchParams.get("utmid");
    let utmToken = url.searchParams.get("utm_token");
    setUser(user);
    setUtmId(utmId);
    setUtmToken(utmToken);

    if (interviewKitId) {
      callApi(interviewKitId);
    } else {
      setLoadingError("Unable to find the assessment kit you are looking for.");
    }
  }, []);

  useEffect(() => {
    if (acceptAssignedAssessmentKitDetailsData?.data) {
      let data = acceptAssignedAssessmentKitDetailsData?.data;
      let total_time = 0;
      let total_question = 0;
      data?.topics &&
        Array.isArray(data?.topics) &&
        data.topics.forEach((element) => {
          element?.questions &&
            element.questions.forEach(
              (time) => (total_time = time + total_time)
            );
          total_question =
            Array.isArray(element?.questions) &&
            element?.questions &&
            element.questions.length + total_question;
        });

      data["total_question"] = total_question;
      data["total_time"] = total_time;
      setInterviewKit(acceptAssignedAssessmentKitDetailsData?.data);
    }
  }, [acceptAssignedAssessmentKitDetailsData]);

  // useEffect(() => {
  //   let isApplyNow = location?.state && location.state?.isApplyNow;
  //   let kitId = location?.state && location.state?.kitId;
  //   if (loggedInMetaData?.data) {
  //     if (isApplyNow) {
  //       if (!candidateAccepted) {
  //         acceptLoading(true);
  //         onAcceptAssessmentKitClick(true, kitId);
  //       }
  //     }
  //   }
  // }, [loggedInMetaData]);

  const callApi = async (interviewKitId) => {
    setLoading(true);
    await dispatch(
      accept_assigned_assessment_kit_details_candidate_action(interviewKitId)
    );
    setLoading(false);
  };

  const callUserApi = async (id) => {
    setLoading(true);
    //call user api
    await dispatch(get_loggedin_user_meta_data_action());
    setLoading(false);
  };

  const getUserToken = async (id) => {
    const token = await localStorage.getItem("jigsawUser");
    setUserToken(JSON.parse(token));
  };

  const onPracticeClick = () => {
    navigate(
      `/interview-instructions?practice=${interviewKit?.id}&appliedJob=${1001}`
    );
  };

  const onStartClick = () => {
    navigate(
      `/interview-instructions?appliedJob=${1001}&interviewKit=${
        interviewKit?.id
      }`
    );
  };

  const onSubmitClick = () => {
    navigate(
      `/interview-submit-review?appliedJob=${1001}&interviewKit=${
        interviewKit?.id
      }`
    );
  };

  const onAcceptAssessmentKitDetailsClick = (is_accepted) => {
    if (userToken) {
      if (userInfo?.role === "candidate") {
        onAcceptAssessmentKitClick(is_accepted);
      }
    } else {
      if (user && utmId && utmToken) {
        navigate(`/invite-password-reset/${utmId}/${utmToken}?user=${user}`, {
          state: {
            navigateRoute: `/view-assessment-kit/${interviewKit?.id}`,
            isApplyNow: true,
            kitId: interviewKit?.id,
          },
        });
      } else if (user) {
        navigate("/sign-in", {
          state: {
            navigateRoute: `/view-assessment-kit/${interviewKit?.id}`,
            isApplyNow: true,
            kitId: interviewKit?.id,
          },
        });
      } else {
        navigate("/sign-in", {
          state: {
            navigateRoute: `/view-assessment-kit/${interviewKit?.id}`,
          },
        });
      }
    }
  };

  const onAcceptAssessmentKitClick = async (is_accepted, kitId) => {
    setAcceptLoading(true);
    if (!candidateAccepted && interviewKit?.id) {
      const data = is_accepted
        ? { kit_accepted: is_accepted }
        : { kit_declined: !is_accepted };
      let res = await dispatch(
        accept_assigned_assessment_kit_candidate_action(interviewKit?.id, data)
      );

      if (res?.data) {
        setCandidateAccepted(true);

        navigate(
          `/interview-instructions?interviewKit=${
            interviewKit?.id
          }&appliedJob=${1001}`
        );
      }
    }

    setAcceptLoading(false);
  };

  const onReadMoreClick = () => {
    setReadMore(!readMore);
  };

  const handleIsDeclineAssessmentModal = () => {
    setIsDeclineAssessmentModal(!isDeclineAssessmentModal);
  };
  return {
    loading,
    loadingError,
    interviewKit,
    readMore,
    acceptLoading,
    isDeclineAssessmentModal,
    userToken,
    onReadMoreClick,
    onPracticeClick,
    onStartClick,
    onSubmitClick,
    onAcceptAssessmentKitClick,
    handleIsDeclineAssessmentModal,
    onAcceptAssessmentKitDetailsClick,
  };
}

export default useAssementKitDetails;
